import { NavLink } from 'react-router-dom'
import { useViewerRole } from '@/auth/useViewerRole'
import { navigationConfig } from './config.js'
import { filterNav } from './filterNav.js'
import { useStatsMy } from './useStatsMy.js'

/**
 * Declarative, role-adaptive sidebar for the Request Center module.
 *
 * Non-permitted items are absent from the DOM (not CSS-hidden), per Spec 0's
 * defense-in-depth requirement. Backend endpoints remain the source of truth
 * for authorization.
 */
export function Sidebar() {
	const { role } = useViewerRole()
	const { hadEverPendingApproval } = useStatsMy()

	const groups = filterNav(navigationConfig, { role, hadEverPendingApproval })

	return (
		<nav aria-label="Primary navigation" className="flex flex-col gap-4">
			{groups.map((group) => {
				// The `personal` group renders without a header (it contains Dashboard + My items).
				// Every other group MUST declare a `label` (enforced by config conventions).
				const showHeader = group.group !== 'personal'
				return (
					<div key={group.group}>
						{showHeader && (
							<div className="px-3 mb-1 text-xs font-semibold uppercase tracking-wider text-gray-400">
								{group.label}
							</div>
						)}
						<ul className="space-y-0.5">
							{group.items.map((item) => (
								<li key={item.route}>
									<NavLink
										to={item.route}
										end={item.route === '/dashboard'}
										className={({ isActive }) =>
											isActive
												? 'block px-3 py-1.5 rounded-md text-sm bg-gray-900 text-white font-medium'
												: 'block px-3 py-1.5 rounded-md text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100'
										}
									>
										{item.label}
									</NavLink>
								</li>
							))}
						</ul>
					</div>
				)
			})}
		</nav>
	)
}
